import { Select } from "antd";
import * as React from "react";
import { useStoreActions, useStoreState } from "../../store/hooks/easyPeasy";
const { Option } = Select;

export interface SelectGroup {
  onChange?: any;
  selected?: any;
  defaultSelected?: any;
  style?: any
}

export const SelectGroup = ({
  onChange,
  selected,
  defaultSelected,
  style
}: SelectGroup) => {
  const itemList = useStoreState((state) => state.student.groupList);
  const itemListFetch = useStoreActions((state) => state.student.fetchgroupList);

  if (itemList === null) {
    itemListFetch();
  }
  
  const onSelect = (id) => {
    if (itemList) {
      const value = itemList.find((item) => item.id === id);
      onChange(value.id);
    }
  };





  return (
    <Select
      onChange={onSelect}
      // loading={loading}
      showSearch
      // allowClear
      defaultValue={defaultSelected}
      value={selected}
      style={style}
      placeholder="Select Group"
      filterOption={(input, option:any) =>
        option !== undefined &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {itemList ? (
        itemList.map((type, idx) => (
          <Option key={type.id} value={type.id}>
            {type.name}
          </Option>
        ))
      ) : (
        <Option value="fetching">Fetching Group</Option>
      )}
    </Select>
  );
};
